import React from 'react';

export const EditRound = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_13865_28725)">
        <path
          d="M4 12C4 5.39062 9.34375 0 16 0C22.6094 0 28 5.39062 28 12C28 18.6562 22.6094 24 16 24C9.34375 24 4 18.6562 4 12ZM20.7344 6.5625C20.0312 5.85938 18.8125 5.85938 18.1094 6.5625L17.0781 7.59375L20.4062 10.9219L21.4375 9.89062C22.1406 9.14062 22.1406 7.96875 21.4375 7.26562L20.7344 6.5625ZM10.7031 14.25L10 17.0625C9.95312 17.3438 10 17.625 10.1875 17.8125C10.375 18 10.6562 18.0469 10.8906 18L13.75 17.2969C13.9844 17.2031 14.2188 17.0625 14.4062 16.875L19.375 11.9531L16.0469 8.625L11.0781 13.5469C10.8906 13.7812 10.75 14.0156 10.7031 14.25Z"
          fill="url(#paint0_linear_13865_28725)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_13865_28725"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13865_28725" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13865_28725" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_13865_28725"
          x1="4.25"
          y1="23.75"
          x2="28"
          y2="2.98605e-07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6D6D6" />
          <stop offset="1" stopColor="#E8E8E8" />
        </linearGradient>
      </defs>
    </svg>
  );
};
